import { useUnits } from '../../units/UnitContext';
import { unitLabel } from '../../units/unitConversions';
import FitToleranceZones from './FitToleranceZones';
import {
  formatMicrometres,
  formatMillimetres,
  getFitPrecision,
} from './fitDisplay';

const CLASSIFICATION_METRICS = {
  clearance: (fit) => [
    ['Minimum clearance', fit.clearance.minimumUm],
    ['Maximum clearance', fit.clearance.maximumUm],
  ],
  transition: (fit) => [
    ['Maximum possible interference', fit.transition.maximumInterferencePossibleUm],
    ['Maximum possible clearance', fit.transition.maximumClearancePossibleUm],
  ],
  interference: (fit) => [
    ['Minimum interference', fit.interference.minimumUm],
    ['Maximum interference', fit.interference.maximumUm],
  ],
};

const ToleranceDetails = ({ label, tolerance, precision, unitSystem }) => (
  <article className="fitToleranceDetails">
    <p>{label}</p>
    <h3>{tolerance.designation}</h3>
    <dl>
      <div><dt>Lower deviation</dt><dd>{formatMicrometres(tolerance.deviations.lowerUm, true, unitSystem)}</dd></div>
      <div><dt>Upper deviation</dt><dd>{formatMicrometres(tolerance.deviations.upperUm, true, unitSystem)}</dd></div>
      <div><dt>Minimum limit</dt><dd>{formatMillimetres(tolerance.limits.minimumMm, precision, unitSystem)} {unitLabel('mm', unitSystem)}</dd></div>
      <div><dt>Maximum limit</dt><dd>{formatMillimetres(tolerance.limits.maximumMm, precision, unitSystem)} {unitLabel('mm', unitSystem)}</dd></div>
      <div><dt>Tolerance width</dt><dd>{formatMicrometres(tolerance.toleranceWidthUm, false, unitSystem)}</dd></div>
    </dl>
  </article>
);

const FitResult = ({ result }) => {
  const { fit, hole, shaft } = result;
  const { unitSystem } = useUnits();
  const precision = getFitPrecision(result);
  const metrics = CLASSIFICATION_METRICS[fit.classification](fit);

  return (
    <section className="fitResult" aria-labelledby="fit-result-title">
      <header className="fitResultHeader">
        <div>
          <h2 id="fit-result-title">{hole.designation}/{shaft.designation}</h2>
          <p>{fit.classification.toUpperCase()} FIT</p>
        </div>
        <span>Ø {formatMillimetres(result.diameter, precision, unitSystem)} {unitLabel('mm', unitSystem)}</span>
      </header>

      <dl className="fitPrimaryMetrics">
        {metrics.map(([label, value]) => (
          <div key={label}><dt>{label}</dt><dd>{formatMicrometres(value, false, unitSystem)}</dd></div>
        ))}
      </dl>
      <p className="fitSignedRange">
        Signed clearance range: {formatMicrometres(fit.signedClearance.minimumUm, true, unitSystem)} to{' '}
        {formatMicrometres(fit.signedClearance.maximumUm, true, unitSystem)}
      </p>

      <div className="fitToleranceGrid">
        <ToleranceDetails label="Hole" tolerance={hole} precision={precision} unitSystem={unitSystem} />
        <ToleranceDetails label="Shaft" tolerance={shaft} precision={precision} unitSystem={unitSystem} />
      </div>
      <FitToleranceZones hole={hole} shaft={shaft} />
    </section>
  );
};

export default FitResult;
